export function LabPage() {
  return (
    <div className="bg-slate-950 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300">
            AVUX Lab
          </p>
          <h1 className="mt-4 text-4xl font-semibold text-white">
            A sandbox for AI-first experiences and emerging interface patterns.
          </h1>
          <p className="mt-4 text-slate-300">
            AVUX Lab experiments de-risk AI adoption and deliver tested patterns for client teams.
          </p>
        </header>
        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">Mirror Match</h2>
            <p className="mt-3 text-sm text-slate-300">
              Neurodiverse emotional processing with guided AI feedback loops.
            </p>
          </article>
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">Dorkinator</h2>
            <p className="mt-3 text-sm text-slate-300">
              AI-assisted investigation queries for OSINT and knowledge work.
            </p>
          </article>
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">Just-in-Time Interfaces</h2>
            <p className="mt-3 text-sm text-slate-300">
              Intent-based workflows generating bespoke UI for the task at hand.
            </p>
          </article>
          <article className="rounded-3xl border border-white/10 bg-white/5 p-8 text-slate-100">
            <h2 className="text-2xl font-semibold text-white">MCP Integrations</h2>
            <p className="mt-3 text-sm text-slate-300">
              Figma ↔ Storybook ↔ code pipelines that keep design systems in sync.
            </p>
          </article>
        </div>
      </div>
    </div>
  );
}
